module.exports = __webpack_public_path__ + "static/media/xs.0844605c.png";